module.exports = __webpack_public_path__ + "static/media/service-contract-add.66d9c788.svg";